import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteEmailTemplate = {
  name: "deleteEmailTemplate" as const,
  input: z.object({ emailTemplateId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
